<script>
	//Design system compoennts
	import { ToggleV2, Text } from '@Shelly/shelly-design-system';

	export let enabled,
		description,
		request,
		title = 'Title';
</script>

<div class="d-flex gap-s justify-content-between align-items-center">
	<div>
		<Text styleType="body" class="mb-s">{title}</Text>
		<Text styleType="body-small" class=" text-color-muted">{description}</Text>
	</div>
	<ToggleV2
		size="m"
		aria-label={title}
		checked={enabled}
		on:click={() => request(enabled ? 0 : 1)}
		id="toggle-notification"
	/>
</div>
